import util from '@bmp-vue/core/api/util'
const controller = 'Default'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
})
